import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function cursoopinionComboReducer(state= initialState.cursoopinionCombo, action){
	switch(action.type){
		case types.GET_CURSOOPINIONS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}